import React from 'react';
import SectionHeading from '../SectionHeading';
import Button from '../Button';
import { pageTitle } from '../../helpers/PageTitle';

export default function ErrorPage() {
  pageTitle('Error');
  return (
    <div className="min-h-screen flex items-center justify-center bg-cream px-6 py-16 text-center">
      <div className="flex flex-col items-center gap-8">
        <SectionHeading title="This page could <br> not be found." titleUp="404 Error" center />
        <Button btnText="Back To Home" btnUrl="/" />
      </div>
    </div>
  );
}
